import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import IntInput from "components/Input/IntInput.js";
import Button from "@mui/material/Button";
import EditButton from "components/CustomButtons/Button.js";
import { makeStyles, withStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";
import { NotificationManager } from "react-notifications";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import DateInput from "components/Input/DateInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { postMBMCampaignView, putMBMCampaignView, getChartList, getPoints } from "services/ConfigServices";
import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { campaigncharttext, campaignviewtext } from "variables/MBM/campaign";
import { chartsourceData, charttypefullData, chartgranularityData, chartgranularityfullData } from "variables/MBM/lists/campaign"
import DataTable from "react-data-table-component";
import _ from "lodash";
import ChartDialog from "./ChartDialog";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddChartToView from "./AddChartToView";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ChartDialogV2 from "./ChartDialogV2.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles2 = makeStyles(styles);
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "0px",
    marginRight: "auto",
    marginLeft: "auto",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "0px",
    marginRight: "auto",
    marginLeft: "auto",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const emailPattern = new RegExp(
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
);

function ViewEditionDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbmadmin = permis.includes("mbm_admin");
  const { closeModal, refetch, setLoading, currentView, campaignid, campaigngroup, points } = props;

  const [view, setView] = useState(currentView || {});
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = advancedSearchContext;

  const [name, setName] = useState(view?.parameters?.general?.name || "");
  const [groups, setGroups] = useState(view?.parameters?.general?.groups ? "" + view.parameters?.general?.groups : "");
  const [datebegin, setDatebegin] = useState(view?.parameters?.general?.datebegin || "");
  const [dateend, setDateend] = useState(view?.parameters?.general?.dateend || "");
  const [columns, setColumns] = useState(view?.parameters?.general?.columns || "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [charts, setCharts] = useState(view?.parameters?.charts || []);
  const [currentchart, setCurrentchart] = useState("");
  const [openchart, setOpenchart] = useState(false);
  const [openchart2, setOpenchart2] = useState(false);

  const [existingcharts, setExistingcharts] = useState([]);
  const [existingChartsData, setExistingChartsData] = useState([]);
  const [weatherpoints, setWeatherpoints] = useState([]);

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handleDatebeginChange = (event) => {
    setDatebegin(event.target.value);
  };
  const handleDateendChange = (event) => {
    setDateend(event.target.value);
  };
  const handleColumnsChange = (event) => {
    setColumns(event.target.value);
  };
  const handleGroupsChange = (value) => {
    setGroups(value);
  };

  const classes = useStyles();
  const classes2 = useStyles2();
  const [value, setValue] = useState("0");

  useEffect(() => {
    axios
      .get(
        getChartList(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        var existingchartstmp = [];
        for (var element in res.data) {
          existingchartstmp.push({
            id: Number(element),
            name: res.data[element].name,
            type: res.data[element].type,
            granularity: res.data[element].granularity,
          });
        }
        setExistingcharts(existingchartstmp);
      });
  }, []);

  useEffect(() => {
    if (groups) {
      axios
        .get(getPoints(groups, [924, 1300]), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          let wpoints = res.data.points.map((point) => {
            let newpoint = { ...point, name: point.name + ' ' + groupInfoListById["" + point.groupid] };
            return newpoint;
          });
          setWeatherpoints(wpoints);
        });
    }
  }, [groups]);

  useEffect(() => {
    let tmpchartsdata = existingcharts.filter((item) =>
      !charts || !charts.find((x) => x.existingchartid == item.id) //que les équipements qui ne sont pas déjà dans la liste des équipement de la campagne
    );
    setExistingChartsData(tmpchartsdata);
  }, [charts, existingcharts]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSubmit = (event) => {
    if (currentView)
      updateView();
    else
      createView(event);
  };

  useEffect(() => {
    if (!name || !columns || !groups || groups.length === 0 || groups === '0')
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const createView = async (event) => {
    const general = {
      name,
      groups,
      datebegin,
      dateend,
      columns,
    }
    const parameters = {
      general,
      charts
    }
    axios
      .post(
        postMBMCampaignView(),
        {
          parameters,
          campaignid
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          let newview = {
            parameters,
            id: res.data.id
          };
          setView(newview);
          setNotification("success", "Vue créée");
          refetch();
          closeModal();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const updateView = async () => {
    const general = {
      ...view.parameters.general,
      name,
      groups,
      datebegin,
      dateend,
      columns
    }
    const parameters = {
      ...view.parameters,
      general,
      charts
    }
    axios
      .put(
        putMBMCampaignView(view.id),
        {
          parameters,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            "Content-Type": "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          let newview = {
            parameters,
            id: view.id
          };
          setView(newview);
          setNotification("success", "Vue modifiée");
          refetch();
          closeModal();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        // setLoading(false);
      });
  };

  const chartsColumns = [
    {
      name: campaigncharttext.position,
      selector: (row) => row.position,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => row.position,
    },
    {
      name: campaigncharttext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.source === 'existing' ? existingcharts.find((x) => x.id == row.existingchart)?.name : row.name
    },
    {
      name: campaigncharttext.source,
      selector: (row) => row.source,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => chartsourceData.find((x) => x.id == row.source)?.name || "Graphique avancé"
    },
    {
      name: campaigncharttext.type,
      selector: (row) => row.type,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.source === 'existing' ? charttypefullData.find((a) => a.id == (existingcharts.find((x) => x.id == row.existingchart)?.type))?.name || "" :
        charttypefullData.find((x) => x.id == row.type)?.name || ""
    },
    {
      name: campaigncharttext.granularity,
      selector: (row) => row.granularity,
      sortable: true,
      cell: (row) => row.source === 'existing' ? chartgranularityfullData.find((a) => a.id == (existingcharts.find((x) => x.id == row.existingchart)?.granularity))?.name || "" :
        chartgranularityData.find((x) => x.id == row.granularity)?.name || ""
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Monter la position">
              <EditButton
                onClick={upChart(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == 1}
              >
                <ArrowDropUpIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Descendre la position">
              <EditButton
                onClick={downChart(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == charts.length}
              >
                <ArrowDropDownIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Editer le graphique">
              <EditButton
                onClick={editChart(row)}
                color={"warning"}
                className={classes2.actionButton}
                disabled={row.source === 'existing'}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Supprimer le graphique de la vue">
              <CustomDeleteButton
                deleteTitle={"Suppression du graphique"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le graphique de la vue?`}
                handleSupprimer={deleteChartFromViewFunction(row)}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ]

  const upChart = (row) => async () => {
    let newcharts = [...charts];
    let obj = newcharts.find((o) => o.id === row.id);
    let oldposition = obj.position;
    let newposition = oldposition - 1; //ie 3 -> 2
    let replacedchart = newcharts.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedchart.position = oldposition;
    setCharts(newcharts);
  }

  const downChart = (row) => async () => {
    let newcharts = [...charts];
    let obj = newcharts.find((o) => o.id === row.id);
    let oldposition = obj.position;
    let newposition = oldposition + 1; //ie 3 -> 4
    let replacedchart = newcharts.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedchart.position = oldposition;
    setCharts(newcharts);
  }

  const handleClickOpenChart = () => {
    setOpenchart(true);
  };
  const handleEditCloseChart = () => {
    setOpenchart(false);
  };
  const handleClickOpenChart2 = () => {
    setOpenchart2(true);
  };
  const handleEditCloseChart2 = () => {
    setOpenchart2(false);
  };

  const editChart = (row) => async () => {
    let obj = charts.find((o) => o.id === row.id);
    if (obj) {
      setCurrentchart(obj);
      if (obj.version && obj.version === 'v2')
        handleClickOpenChart2();
      else
        handleClickOpenChart();
    }
  }
  const deleteChartFromViewFunction = (row) => async () => {
    let newcharts = charts.filter((o) => o.id !== row.id);
    setCharts(newcharts);
  };

  const [filterTextChart, setFilterTextChart] = useState("");
  const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
  const SearchComponentChart = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItemsChart = charts.filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterTextChart.toLowerCase())) ||
      (item.source && chartsourceData.find((x) => x.id == item.source) && chartsourceData.find((x) => x.id == item.source).name.toLowerCase().includes(filterTextChart.toLowerCase()))
  );
  const subHeaderComponentMemoChart = useMemo(() => {
    const handleClearChart = () => {
      if (filterTextChart) {
        setResetPaginationToggleChart(!resetPaginationToggleChart);
        setFilterTextChart("");
      }
    };
    const onFilterTextChart = (e) => setFilterTextChart(e.target.value);

    return (
      <>
        <SearchComponentChart
          key="SearchComponentChart"
          onFilter={onFilterTextChart}
          onClear={handleClearChart}
          filterText={filterTextChart}
        />
        {mbmadmin && (
          <>
            <UploadButton type="button" onClick={handleClearChart}>
              <AddChartToView
                onClick={handleClearChart}
                existingChartsData={existingChartsData}
                points={points.concat(weatherpoints)}
                setCharts={setCharts}
                charts={charts}
              //weatherpoints={weatherpoints}
              // currentchart={currentchart}
              />
            </UploadButton>
          </>
        )}
      </>
    );
  }, [filterTextChart, resetPaginationToggleChart, charts, existingChartsData, weatherpoints]);

  return (
    <>
      <DialogContent dividers style={{ height: "90vh" }}>
        <TabContext value={value} className={classes.root}>
          <div className={classes.demo2}>
            <AppBar
              position="static"
              className={classes.demo3}
              style={{ boxShadow: "none", shadowColor: "red" }}
            >
              <StyledTabs
                value={value}
                onChange={handleChange}
                aria-label="styled tabs example"
                scrollButtons="auto"
              >
                <StyledTab label="Paramètres généraux" value="0" />
                <StyledTab label="Graphiques" value="1" />

              </StyledTabs>
              <Typography className={classes.padding} />
            </AppBar>
            <Divider variant="fullWidth" />
            <TabPanel value="0">
              <form className={classes.root}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={7} lg={7}>
                    <div>
                      <TextInput
                        isRequired
                        inputTitle={campaignviewtext.name}
                        textInput={name}
                        handleTextInputChange={handleNameChange}
                      />
                    </div>
                    <div>
                      <DateInput
                        inputTitle={campaignviewtext.datebegin}
                        dateInput={datebegin}
                        handleDateInputChange={handleDatebeginChange}
                      />
                    </div>
                    <div>
                      <DateInput
                        inputTitle={campaignviewtext.dateend}
                        dateInput={dateend}
                        handleDateInputChange={handleDateendChange}
                      />
                    </div>
                    <div>
                      <IntInput
                        inputTitle={campaignviewtext.columns}
                        intInput={columns}
                        handleIntInputChange={handleColumnsChange}
                      />
                    </div>

                  </GridItem>
                  <GridItem xs={12} sm={6} md={5} lg={5}>
                    <div
                      className={classes.treeVisible}
                    >
                      <TreeLabel>Groupe par défaut</TreeLabel>
                      <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                        <EmbeddedEntitesTree
                          selectedIds={handleGroupsChange}
                          userSelectedIds={groups}
                          filterfromnode={campaigngroup}
                        />
                      </ImageList>
                    </div>
                  </GridItem>
                </GridContainer>
              </form>
            </TabPanel>
            <TabPanel value="1">
              <Container>
                <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                  noDataComponent={<NoData>{"Aucun graphique"}</NoData>}
                  noHeader={true}
                  columns={chartsColumns}
                  persistTableHead
                  pagination
                  subHeader
                  data={filteredItemsChart}
                  paginationComponentOptions={{
                    noRowsPerPage: false,
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                    selectAllRowsItem: false,
                    selectAllRowsItemText: "Selectionner toutes les lignes",
                  }}
                  defaultPageSize={10}
                  filterable={true}
                  defaultSortFieldId={1}
                  manual={true}
                  paginationResetDefaultPage={setResetPaginationToggleChart}
                  subHeaderComponent={subHeaderComponentMemoChart}
                />
              </Container>
            </TabPanel>

          </div>

        </TabContext>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </DialogActions>
      <Dialog
        onClose={handleEditCloseChart}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openchart}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseChart}>
          Edition d'un graphique
        </CustomDialogTitle>
        <DialogContent dividers>
          <ChartDialog
            closeModal={handleEditCloseChart}
            existingChartsData={existingChartsData}
            points={points.concat(weatherpoints)}
            setCharts={setCharts}
            charts={charts}
            currentchart={currentchart}
          // weatherpoints={weatherpoints}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditCloseChart2}
        aria-labelledby="addMarket-dialog-title"
        fullWidth={true}
        maxWidth="lg"
        open={openchart2}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleEditCloseChart2}>
          Ajout d'un graphique
        </CustomDialogTitle>
        <ChartDialogV2
          closeModal={handleEditCloseChart2}
          existingChartsData={existingChartsData}
          points={points.concat(weatherpoints)}
          setCharts={setCharts}
          charts={charts}
          currentchart={currentchart}
        // weatherpoints={weatherpoints}
        />
      </Dialog>
    </>
  );
}

export default ViewEditionDialog;
